import React from "react";

const ClassificationKPICard = ({ 
  entry, 
  totalAccounts, 
  onClick, 
  index 
}) => {
  const percentage = totalAccounts === 0
    ? "0%"
    : `${((entry.value / totalAccounts) * 100).toFixed(2)}%`;

  return (
    <div
      onClick={() => onClick(entry.name)}
      className="group relative overflow-hidden hover:scale-105 transition-transform duration-300 cursor-pointer"
      style={{
        width: "220px",
        height: "110px",
        borderRadius: "10px",
        background:
          "linear-gradient(252.82deg, rgba(217, 217, 217, 0.025) 25.41%, rgba(115, 108, 207, 0.005) 115.2%)",
        backdropFilter: "blur(75px)",
        border: "0px solid",
        opacity: 1,
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      <div className="relative z-10 p-4">
        <p
          className="text-[#D3B4FF] text-lg font-medium mb-2"
          style={{
            fontFamily: "Inter",
            fontWeight: 300,
            fontStyle: "Light",
            fontSize: "14px",
            lineHeight: "100%",
            letterSpacing: "1%",
            opacity: 1,
            position: "absolute",
            top: "20px",
            left: "16px",
            transform: "rotate(0deg)",
          }}
        >
          {entry.name} Accounts
        </p>

        <div
          className="text-2xl font-extrabold text-[#d3d3d3]"
          style={{
            fontFamily: "Inter",
            fontWeight: 700,
            fontStyle: "Bold",
            fontSize: "28px",
            lineHeight: "100%",
            letterSpacing: "1%",
            opacity: 1,
            position: "absolute",
            top: "60px",
            left: "16px",
            transform: "rotate(0deg)",
          }}
        >
          {entry.value}
        </div>

        <div
          className="text-[#D3B4FF] text-sm"
          style={{
            fontFamily: "Inter",
            fontWeight: 300,
            fontStyle: "Light",
            fontSize: "12px",
            lineHeight: "100%",
            letterSpacing: "1%",
            opacity: 1,
            position: "absolute",
            top: "76px",
            right: "16px",
            transform: "rotate(0deg)",
          }}
        >
          {percentage}
        </div>
      </div>
    </div>
  );
};

export default ClassificationKPICard;